import styles from "./Project.module.scss";
import { useTranslation } from "react-i18next";

export default function Projects() {
    const { t } = useTranslation();

    const projects = [
        {
            key: 'guardianKey',
            img: require('../../assets/images/guardianKey.png'),
            hasLink: false,
            soon: true
        },
        {
            key: 'locationApi',
            img: require('../../assets/images/api.png'),
            hasLink: true,
            link: 'https://github.com/victorcasag',
            soon: false
        },
        {
            key: 'compiler',
            img: require('../../assets/images/logo.webp'),
            hasLink: true,
            link: 'https://github.com/victorcasag',
            soon: false
        },
        {
            key: 'gymErp',
            img: require('../../assets/images/produlink.webp'),
            hasLink: true,
            link: 'https://github.com/victorcasag',
            soon: false
        }
    ];

    return (
        <section id="Projects" className={`${styles.projects} container`}>
            <h1 className={styles.projectsTitle}>{t("Projects.title")}</h1>

            {projects.map((project) => (
                <article key={project.key} className={`${styles.project} ${styles[project.key]}`}>
                    <h2 className={styles.projectTitle}>{t(`Projects.${project.key}.title`)}</h2>
                    <div className={styles.projectBody}>
                        <img
                            src={project.img}
                            alt={t(`Projects.${project.key}.title`)}
                            className={styles.projectImage}
                        />
                        <div className={styles.projectContent}>
                            <p className={styles.projectDescription}>
                                {t(`Projects.${project.key}.description`)}
                            </p>
                            <p className={styles.projectStack}>
                                <strong>Stack:</strong> {t(`Projects.${project.key}.stack`)}
                            </p>
                        </div>
                    </div>
                    <div className={styles.buttonContainer}>
                        {project.hasLink ? (
                            <button
                                className={styles.buttonSeeProject}
                                onClick={() => window.open(project.link, '_blank')}
                            >
                                {t(`Projects.${project.key}.button`)}
                            </button>
                        ) : (
                            <>
                                <button className={styles.buttonSeeProjectDisabled}>
                                    {t(`Projects.${project.key}.button`)}
                                </button>
                                <span className={styles.buttonText}>{t(`Projects.${project.key}.soon`)}</span>
                            </>
                        )}
                    </div>
                </article>
            ))}
        </section>
    );
}
